import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ActivationForm } from 'components/modules';
import i18n from 'config/i18n';
import { PortalFormWrapper, PoweredBy, PortalWelcomeText } from 'components/elements';
import { useAuthActions, useQuery } from 'hooks';
import Styles from './styles';
import LinkExpired from './LinkExpired';
import ActivationSuccess from './AccountActivationSuccess';

const useStyles = makeStyles(Styles);

function AccountActivation() {
  const classes = useStyles();
  const { tag } = useQuery();
  const { t } = useTranslation('labels');
  const [isLinkExpired, setIsLinkExpired] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { getAccountClaim } = useAuthActions();
  useEffect(async () => {
    setIsLoading(true);
    const accountClaim = await getAccountClaim({ tag });
    if (accountClaim.profile != null) i18n.changeLanguage(accountClaim.profile.language);
    setIsLinkExpired(accountClaim.isExpired);
    setIsLoading(false);
  }, [tag]);

  return (
    <>
      <PortalFormWrapper>
        <>
          <PortalWelcomeText isForm />
          {!isLoading && (
            <>
              {!isSubmitted && !isLinkExpired && (
                <>
                  <Typography className={classes.formSubtitle} variant="h6" component="div">
                    <strong>{t('please_fill_in_the_fields_below_to_activate_your_account')}</strong>
                  </Typography>
                  <Typography className={classes.formSubtitle} variant="h6" component="div">
                    {t('passwords_should_be_a_minimum_of')}
                    <strong className={classes.strongText}> 8 {t('characters')} </strong>
                    <span className={classes.text}>{t('and_contain_a_combination_of')}</span>:
                    <strong className={classes.strongText}> {t('numbers_uppercase_lowercase_special_characters')}. </strong>
                    <br />
                    {t('your_activation_code_has_been_texted_to_your_mobile_number_on_file')}
                  </Typography>
                </>
              )}
              {isSubmitted && !isLinkExpired && <ActivationSuccess />}
              {isLinkExpired && <LinkExpired />}
              {!isSubmitted && !isLinkExpired && <ActivationForm tag={tag} onSubmit={() => setIsSubmitted(true)} />}
            </>
          )}
        </>
      </PortalFormWrapper>
      <PoweredBy />
    </>
  );
}

export default AccountActivation;
